import React, {useState, useEffect} from 'react';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, isVerifyEmail, isProvider, userToken, logout } from "../../features/user";
import { isShowUserPopup, setShowUserPopup, showMessage } from "../../features/common";

import axios from "axios";
import { API_200, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION, SHARE_URL } from '../../Constants';
import {Trans, useTranslation } from 'react-i18next';
import {checkApiSessionErrorMessage, checkValidToken, userLoggedIn, getLang, translateList, arrayBufferToBase64, navigateTo, showLoading } from "../../Helper"

import Frame from '../widgets/Frame';
import Background from '../widgets/Background';
import ProviderSummary from '../widgets/ProviderSummary';


export function Provider() {
    const [state, setState] = useState({provider:{}, selectedService : 0, viewProfile: false});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const { id } = useParams();

    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);
    const isUserProvider = useSelector(isProvider);
    const showUserPopup = useSelector(isShowUserPopup) && isUserProvider;

    useEffect(()=>{
        (async () => {
            await checkValidToken(navigate, dispatch, false, true, "/start");
            if(userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)){
                
                if(id) {
                    getProvider(id);
                } else if(isUserProvider) {
                    getProvider(null);
                } else {
                    navigate(-1);
                }
            }
        })();
        // eslint-disable-next-line
    },[]);

    const getProvider = async (id) => {
        showLoading(dispatch, true);
        let errorMessage = DEFAULT_ERROR_TEXT;

        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

        try {
            const reply = await axios.get(id?`${API_URL }/providers/details/${id}`:`${API_URL }/provider`, config);
            showLoading(dispatch, false);
            //console.log(reply);
            if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_200) {
                setState({
                    ...state,
                    provider: reply.data
                });
                if(isUserProvider && !id && !(reply.data?.specialization && Object.keys(reply.data?.specialization).length > 0)) {
                    navigate('/provider-required-info');
                }
            }
        } catch (e) {
            showLoading(dispatch, false);
            if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                errorMessage = e.response.data["errors"][0];
            }
            if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
                dispatch(showMessage({message : errorMessage}));
            }
        }
    }


    const packageClick = async (index, name) => {
        setState({
            ...state,
            selectedService: index
        });

        if(id && name && !isUserProvider) {
            let errorMessage = DEFAULT_ERROR_TEXT;

            let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

            try {
                const reply = await axios.get(`${API_URL }/providers/services/${id}/${name}`, config);
            } catch (e) {
                if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                    errorMessage = e.response.data["errors"][0];
                }
                if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
                    dispatch(showMessage({message : errorMessage}));
                }
            }
        }
    };

    const viewAllClick = () => {
        setState({
            ...state,
            viewProfile: !state.viewProfile
        });
    }



    const openUrlClick = (url) => {
        //navigate("/display-link?url="+url);
           window.open(url, '_blank', 'noopener,noreferrer');
        //   window.open(url, '_self', 'noopener,noreferrer');
    };


    const handleShareClick = (provider_id) => {
        if (location.pathname) {
            const link = SHARE_URL+'/provider/'+state.provider._id;
            if(navigator.share) {
                navigator.share({url:link, text:t('share_subject'), title:t('share_my_profile_message')})
            } else {
                navigator.clipboard.writeText(link);
                dispatch(showMessage({message : 'copied_to_clipboard'}));
            }
        }

        //Share.share("${AppLocalizations.of(context)!.share_my_profile_message} https://links.kotvot.com/provider/${item['id']}", subject: AppLocalizations.of(context)!.shere_subject);
        //navigate("/reviews?id="+provider_id);
    };

    const handleEditClick = () => {
        navigateTo(dispatch, navigate, '/edit-provider-profile');
    }; 

    const close = () => {
        dispatch(setShowUserPopup({showUserPopup : false}));
    }

    const userPopup =() => {
        return (
            <div className='user-popup'>
                <img className='user-popup-image mt10' src={'/images/edit.png'}  alt=''/>
                <div className='font-30 font-bold mr40 ml40 mt10'>{t('profile_popup_title')}</div>
                <div className='font-13 mr40 ml40 mt10'>{t('provider_profile_popup_text')}</div>
                <div className='popup-button mt30 mb20' onClick={()=>{close();handleEditClick()}}>{t('edit_profile')}</div>
                <img className='close-icon' src={'/images/close_x.png'} onClick={()=>close()} alt=''/>
            </div>
        )
    }

    const portfolio = () => {
        return (
            <div className={`provider-portfolio-box ${(state.provider.portfolio.length>3 && !state.viewProfile)?'many':''}`}>
                {state.provider.portfolio && state.provider.portfolio.map((portfolio, index) => (
                    <div key={index} className='portfolio-details'>
                        <div className='portfolio-detail'>
                            <div className='portfolio-image-wrapper'>{portfolio.image && <img src={arrayBufferToBase64(portfolio.image)} className='portfolio-image' alt=''/>}</div>
                            <div className='portfolio-info'>
                                {portfolio.name && 
                                    <div>
                                        <span className='font-20 mt5'>{t("the_book")} </span>
                                        <span className='font-20 font-bold'>{portfolio.name}</span>
                                    </div>
                                }
                                {portfolio.writer && 
                                    <div>
                                        <span className='font-20 mt5'>{t("the_writer")} </span>
                                        <span className='font-15 font-bold'>{portfolio.writer}</span>
                                    </div>
                                }
                                {portfolio.work && 
                                    <div>
                                        <span className='font-20 mt5'>{t("work")} </span>
                                        <span className='font-15 font-bold mb5'>{portfolio.work}</span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }


    return (
        <Frame showMenu={true} showNav={!isUserProvider} showBack={id || state.viewProfile?true:false} backOveride={state.viewProfile?viewAllClick:null}>
            <div className='main main-provider'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                    {state.provider?!state.viewProfile?<Background >
                         <div className='right-main-inner'>
                            {(isUserProvider && !id) && <div>
                                <div className='mt30'>
                                    <div className='center-div font-20 font-bold text-align-center'>{t("profile_page_title")}
                                        <img src={'/images/nav/share.png'} onClick={() => handleShareClick(id)} className='ml5 mr5 profile-share-icon' alt=''/>
                                    </div>
                                    <div className='center-div font-15 font-bold text-align-center pointer'  onClick={() => handleEditClick()}>{t("edit")}</div>
                                </div>
                            </div>}
                            <ProviderSummary key={state.provider._id} provider={state.provider}/>
                            <div className='mt20 background-shadow background-EEE9FF'>
                                <div className='provider-box'>

                                    {state.provider.packages && <div className='mt30 provider-package-box'>
                                        <div className='tabs relative flex'>
                                            {state.provider.packages && state.provider.packages.map((providerPackage, index) => (
                                                <div key={index} className={`tab font-15 ${state.selectedService===index?'tab-selected':''}`} onClick={() => packageClick(index, providerPackage.name)}>{providerPackage.name}</div>
                                            ))}
                                        </div>
                                        <div className='package-details'>
                                            <div className='flex justify-content-space-evenly'>
                                                <div className='package-details-quantity font-15 mt15'>{state.provider.packages[state.selectedService].quantity}</div>
                                                <div className='package-details-price font-17 font-bold mt15'>{state.provider.packages[state.selectedService].price}</div>
                                            </div>
                                            <div className='package-details-description font-15 mt20'>{state.provider.packages[state.selectedService].description}</div>
                                            <div className='mt10 pb10 flex justify-content-space-between align-items-center'>
                                                <div className='ml20 mr60 font-12 color-550952'>{t("contact_me")}</div>
                                                <div className='ml20 flex'>
                                                    {state.provider?.media?.email && state.provider.media.email!=='' && <div><img src={'/images/gmail.png'} className='ml10 media-icon' onClick={() => openUrlClick(`mailto:${state.provider.media.email}`)} alt=''/></div>}
                                                    {state.provider?.media?.instagram && state.provider.media.instagram!=='' && <div><img src={'/images/instagram.png'} className='ml10 media-icon' onClick={() => openUrlClick(`https://www.instagram.com/${state.provider.media.instagram}`)} alt=''/></div>}
                                                    {state.provider?.media?.facebook && state.provider.media.facebook!=='' && <div><img src={'/images/facebook.png'} className='ml10 media-icon' onClick={() => openUrlClick(`https://www.facebook.com/${state.provider.media.facebook}`)} alt=''/></div>}
                                                    {state.provider?.media?.whatsapp && state.provider.media.whatsapp!=='' && <div><img src={'/images/whatsapp.png'} className='ml10 media-icon' onClick={() => openUrlClick(`https://wa.me/${state.provider.media.whatsapp}`)} alt=''/></div>}
                                               </div>
                                            </div>
                                        </div>
                                    </div>}

                                    {state.provider.serviceExplanation &&
                                        <>
                                            <div className='font-30 mt15'>{t('explanation_about_the_service')}</div>
                                            <div className='mt10 provider-explanation-box'>
                                                <div className='explanation-details'>
                                                    {state.provider.serviceExplanation}
                                                </div>
                                            </div>
                                        </>
                                    }

                                    {state.provider.genre &&
                                        <>
                                            <div className='font-15 color-262626 mt15'>{t('genre')}</div>
                                            <div className='font-18 color-93278F mt5'>{translateList(Object.values(state.provider.genre), t)}</div>
                                        </>
                                    }

                                    {(state.provider.language && Object.values(state.provider.language).length > 0) &&
                                        <>
                                            <div className='font-15 color-262626 mt15'>{t('language')}</div>
                                            <div className='font-18 color-93278F mt5'>{translateList(Object.values(state.provider.language), t)}</div>
                                        </>
                                    }

                                    {(state.provider.education && state.provider.education.length > 0) &&
                                        <>
                                            <div className='font-30 mt15'>{t('about')}</div>
                                            <div className='mt10 provider-education-box'>
                                                <div className='education-details'>
                                                    {state.provider.education && state.provider.education.map((education, index) => (
                                                        <div key={index}>
                                                            {education.degree_qualification && <div className='font-15 mt5'>{education.degree_qualification}</div>}
                                                            {education.educational_facility && <div className='font-15'>{education.educational_facility}</div>}
                                                            {education.years_studied && <div className='font-15 mb5'>{education.years_studied}</div>}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </>
                                    }

                                    {(state.provider.portfolio && state.provider.portfolio.length > 0) &&
                                        <>
                                            <div className='font-30 mt15'>{t('portfolio')}</div>
                                            <div className='font-15 mb10 '>{state.provider.portfolio.length+' '+t('x_items')} <span className='font-14 font-underline color-93278F' onClick={() => viewAllClick()}>{t('show_all')}</span></div>
                                            {portfolio()}
                                        </>
                                    }

                                    {((state.provider.geographicLocation && state.provider.geographicLocation.trim().length > 0) ||
                                        (state.provider.averageResponseTime && state.provider.averageResponseTime.trim().length > 0) ||
                                        (state.provider.lastOrder && state.provider.lastOrder.trim().length > 0) ||
                                        (state.provider.joinedOn && state.provider.joinedOn.trim().length > 0)) &&
                                        <>

                                            <div className='mt20 provider-info-box'>
                                                <div className='info-details'>
                                                    <div className='flex'>
                                                        <img src={'/images/location.png'} className='location-image' alt=''/>
                                                        {state.provider.geographicLocation && state.provider.geographicLocation.trim().length > 0 && <div className='font-18 color-262626'>{state.provider.geographicLocation}</div>}
                                                    </div>
                                                    <div className='flex mt5'>
                                                        <div className='font-15 color-262626 ml5'>{t('average_response_time')}</div>
                                                        {state.provider.averageResponseTime && state.provider.averageResponseTime.trim().length > 0 && <div className='font-18 color-262626'>{state.provider.averageResponseTime}</div>}
                                                    </div>
                                                    <div className='flex mt5'>
                                                        <div className='font-15 color-262626 ml5'>{t('last_order')}</div>
                                                        {state.provider.lastOrder && state.provider.lastOrder.trim().length > 0 && <div className='font-18 color-262626'>{state.provider.averageResponseTime}</div>}
                                                    </div>
                                                    <div className='flex mt5'>
                                                        <div className='font-15 color-262626 ml5'>{t('joined_on')}</div>
                                                        {state.provider.joinedOn && state.provider.joinedOn.trim().length > 0 && <div className='font-18 color-262626'>{state.provider.averageResponseTime}</div>}
                                                    </div>

                                                </div>
                                            </div>
                                        </>
                                    }

                                    {state.provider.previousProjects &&
                                        <>

                                            <div className='mt20 provider-previous-projects-box'>
                                                <div className='font-14 color-white'>{t('previous_projects')}</div>
                                                <div className='shadow-button-list font-12' onClick={() => openUrlClick(state.provider.previousProjects)}> {t("click_here")} </div>
                                            </div>
                                        </>
                                    }
                                    <div className='mb20'></div>                      
                                </div>

                            </div>
                        </div></Background>:<>{(state.provider.portfolio && state.provider.portfolio.length > 0) &&
                            <div className='center-div background-EEE9FF'><div className='right-main-inner mt10 mb10 '>{portfolio()}</div></div>
                        }</>
                    :null}
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
            {(showUserPopup && isUserProvider) && userPopup()}
        </Frame>
    );
}